import { useTranslation } from 'react-i18next';
import { CardTitle } from '@client/toolkit';
import { FilterButton } from '../../ui';
import { useEosSourcesFilterContext } from './useEosSourcesFilterContext';

export function EosSourcesFilter() {
  const { t } = useTranslation('eos');
  const { sources, setSources } = useEosSourcesFilterContext();
  return (
    <div className="flex flex-col gap-3 w-full text-white">
      <CardTitle className="flex-1" variant="dense">
        {t('source')} ({t('energy')})
      </CardTitle>
      <div className="flex gap-2">
        <FilterButton label="Elhub" isActive={sources.includes('enelyze')} onClick={() => setSources(['enelyze'])} />
        <FilterButton
          label={t('otherSources')}
          isActive={sources.includes('mqtt')}
          onClick={() => setSources(['mqtt'])}
        />
      </div>
    </div>
  );
}
